import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

export function getRouter() {
  return createRouter({
    routeTree,
    defaultPreload: 'intent',
    defaultPreloadDelay: 0,
    defaultPreloadStaleTime: Number.POSITIVE_INFINITY,
    defaultStaleTime: Number.POSITIVE_INFINITY, // The workbench routes resolve static, server-rendered content. Treat loader data as session-permanent so revisiting a route never re-fetches and feels instantaneous.
    defaultPendingMs: Number.POSITIVE_INFINITY, // Hold the previous route on screen until the next loader resolves instead of unmounting into a blank slot. With intent preload + permanent stale time the new loader is usually already done by click time, so this trades a hypothetical "show fallback after 1s" for a guaranteed no-flash transition.
    defaultViewTransition: false,
    defaultStructuralSharing: true,
    scrollRestoration: true,
    notFoundMode: 'fuzzy',
  });
}
